import { Outlet, Link } from "react-router-dom";
import images from "../constants/images";
import { useTranslation } from "react-i18next";
import { useState } from "react";

const Layout = () => {

    const { t, i18n } = useTranslation();
    const [currentLang, setCurrentLang] = useState(i18n.language.split("-")[0])

    const changeLang = () => {

        currentLang === "en" ? i18n.changeLanguage("tr") : i18n.changeLanguage("en")

        currentLang === "en" ? setCurrentLang("tr") : setCurrentLang("en")


    }

    return (
        <div className="bg-primary-bg bg-cover bg-repeat-y">
            <div className="h-24 text-center w-max-screen">
                <div className="flex lg:flex-row gap-x-5 items-center text-md font-semibold text-sunflower h-28">
                    <Link className="" to="/"> <div className="bg-button_color rounded-full h-32 w-32 absolute -top-10 -left-8 border-4">
                        <div className=" relative left-10 top-11">
                            <img className="w-[50px] " src={images.att_app_logo} alt="att" />
                        </div>
                    </div></Link>
                    

                    <div className="ml-20">
                        <div className="bg-beige rounded-full h-32 w-20 absolute -top-10 border-4">
                            <Link className="relative text-center top-16" to="/about">{t('about.title')}</Link>

                        </div>
                    </div>

                    <div className="ml-16">
                        <div className="bg-beige rounded-full h-32 w-20 absolute -top-10 border-4">
                            <Link className="relative text-center top-16" to="/policy/privacy-policy">{t('layout.policy')}</Link>

                        </div>
                    </div>

                    <div className="ml-16">
                        <div className="bg-beige rounded-full h-32  w-16 lg:w-24 absolute -top-10 border-4">
                            <Link className="relative text-center top-16" to="/contact">{t('layout.contact')}</Link>

                        </div>
                    </div>

                </div>


            </div>
            <div onClick={() => { changeLang() }} className="flex cursor-pointer mx-5 justify-end  justify-items-end">
                <p>{currentLang.toUpperCase()}</p>
            </div>

            <div >
                <Outlet />

            </div>
        </div>
    )
};

export default Layout;